import AccessGroupAddDeviceModal from './AccessGroupAddDeviceModal';

export default AccessGroupAddDeviceModal;
